import {
  createSlice,
  createSelector,
  PayloadAction,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import { infoSnack, successSnack, errorSnack } from "../snackbar/snackbarSlice";
// thunkAPI.dispatch(successSnack('Fetched Users'));
// thunkAPI.dispatch(infoSnack('Look at these Users'));
// thunkAPI.dispatch(errorSnack('User error'));
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

export const fetchUsers = createAsyncThunk(
  "users/fetchUsers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/users${args.query}`,
        config
      );
      thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setUsersAmount(response.headers["x-total-count"]));
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching users list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchMoreUsers = createAsyncThunk(
  "users/fetchMoreUsers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/users${args.query}&offset=${args.offset}`,
        config
      );
      // let catQuery = [];
      // if (args.query.includes("categories")) {
      //   let urlSearchParams = new URLSearchParams(args.query);
      //   let params = Object.fromEntries(urlSearchParams.entries());
      //   catQuery = params.categories;
      // }
      // thunkAPI.dispatch(setLastQuery(args.query));
      thunkAPI.dispatch(setUsersAmount(response.headers["x-total-count"]));
      // thunkAPI.dispatch(updateCategories(catQuery));
      return await response.data;
    } catch (error) {
      if (error.message.includes("401")) {
        localStorage.removeItem("coreUser");
        localStorage.removeItem("coreToken");
      }
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description ||
        //       'Error fetching products list'
        //   )
        // );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const filterUsers = createAsyncThunk(
  "users/filterUsers",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };
      const response = await axios.get(
        `${baseURL}/v1/admin/users${args.query}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching users list"
          )
        );
      }
      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchUserAccount = createAsyncThunk(
  "users/fetchUserAccount",
  async (args, thunkAPI) => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${args.token}` },
      };

      //GetFullList Here??
      const response = await axios.get(
        `${baseURL}/v1/admin/users?limit=50`,
        config
      );
      let user = response.data.filter((user) => user.username === args.user);
      //
      return await user[0];
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description ||
              "Error fetching user account"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchUserByID = createAsyncThunk(
  "users/fetchUserByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/users/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching user data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const fetchOrderUserByID = createAsyncThunk(
  "users/fetchOrderUserByID",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(
        `${baseURL}/v1/admin/users/${args.id}`,
        config
      );
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error fetching user data"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.delete(
        `${baseURL}/v1/admin/users/${args.id}`,
        config
      );
      thunkAPI.dispatch(successSnack("User deleted"));
      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deleting user"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.patch(
        `${baseURL}/v1/admin/users/${args.id}`,
        args.user,
        config
      );
      thunkAPI.dispatch(fetchUsers({ token: args.token, query: "?limit=25" }));
      thunkAPI.dispatch(successSnack("User updated"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating user"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const createUser = createAsyncThunk(
  "users/createUser",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.post(
        `${baseURL}/v1/admin/users`,
        args.user,
        config
      );
      thunkAPI.dispatch(fetchUsers({ token: args.token, query: "?limit=25" }));
      thunkAPI.dispatch(successSnack("User created successfully"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error creating user"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const activateUser = createAsyncThunk(
  "users/activateUser",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.patch(
        `${baseURL}/v1/admin/users/${args.id}/activate`,
        config
      );
      thunkAPI.dispatch(successSnack("User activated"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error activating user"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const deactivateUser = createAsyncThunk(
  "users/deactivateUser",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.patch(
        `${baseURL}/v1/admin/users/${args.id}/deactivate`,
        config
      );
      thunkAPI.dispatch(successSnack("User deactivated"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error deactivating user"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const updatePassword = createAsyncThunk(
  "users/updatePassword",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      //full options
      const response = await axios.patch(
        `${baseURL}/v1/admin/users/${args.id}/password`,
        args.passwordUpdate,
        config
      );
      thunkAPI.dispatch(successSnack("Password updated successfully"));

      return await response;
    } catch (error) {
      if (error.response && error.response.data) {
        thunkAPI.dispatch(
          errorSnack(
            error.response.data.error_description || "Error updating password"
          )
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const getFullList = createAsyncThunk(
  "products/getFullList",
  async (args, thunkAPI) => {
    let objToMap = [];
    for (let i = 0; i < (args.targetLength - args.offset) / 100; i++) {
      objToMap.push({
        token: args.token,
        query: args.query,
        offset: args.offset + 100 * i,
      });
    }

    Promise.all(
      objToMap.map((requestData) =>
        thunkAPI.dispatch(fetchMoreUsers(requestData))
      )
    )
      .then((results) => {})
      .catch((err) => {
        return thunkAPI.rejectWithValue("Error fetching full product list");
      });
  }
);

export const fetchMyself = createAsyncThunk(
  "users/fetchMyself",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.get(`${baseURL}/v1/admin/myself`, config);
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        // thunkAPI.dispatch(
        //   errorSnack(
        //     error.response.data.error_description || 'Error fetching user data'
        //   )
        // );
        // thunkAPI.dispatch(logout());
        return thunkAPI.rejectWithValue(
          error.message.includes("401")
            ? { message: "Invalid Username or Password" }
            : { message: error.message }
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

export const logout = createAsyncThunk(
  "users/logout",
  async (args, thunkAPI) => {
    const config = {
      headers: { Authorization: `Bearer ${args.token}` },
    };
    try {
      const response = await axios.delete(`${baseURL}/v1/admin/logout`, config);
      return await response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return thunkAPI.rejectWithValue(
          error.message.includes("401")
            ? { message: "Invalid Username or Password" }
            : { message: error.message }
        );
      }

      return thunkAPI.rejectWithValue({ error: error.message });
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    user: {},
    userUser: {},
    usersList: [],
    usersFilter: [],
    loading: "idle",
    message: "",
    error: "",
    userAccount: {},
    editing: false,
    usersAmount: "",
    lastQuery: "",
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    setLastQuery: (state, action) => {
      state.lastQuery = action.payload;
    },
    setUsersAmount: (state, action) => {
      state.usersAmount = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsers.pending, (state) => {
      state.usersList = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchUsers.fulfilled, (state, { payload }) => {
      state.usersList = payload;
      state.usersFilter = payload;
      state.loading = "loaded";
      state.editing = false;
    });
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchMyself.pending, (state) => {
      state.loading = "loading";
    });
    builder.addCase(fetchMyself.fulfilled, (state, { payload }) => {
      state.userAccount = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchMyself.rejected, (state, action) => {
      state.loading = "error";
    });
    builder.addCase(fetchMoreUsers.fulfilled, (state, { payload }) => {
      state.error = "";
      state.usersList = state.usersList.concat(payload);
      state.loading = "loaded";
    });
    builder.addCase(fetchMoreUsers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(getFullList.fulfilled, (state, { payload }) => {
      state.error = "";
      state.usersList = state.usersList.sort(function (a, b) {
        return a.id - b.id;
      });
      state.loading = "loaded";
    });
    builder.addCase(getFullList.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchUserAccount.pending, (state) => {
      state.userAccount = {};
      state.loading = "loading";
    });
    builder.addCase(fetchUserAccount.fulfilled, (state, { payload }) => {
      state.userAccount = payload;
      state.loading = "loaded";
    });
    builder.addCase(fetchUserAccount.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(fetchUserByID.pending, (state) => {
      state.user = {};
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(fetchUserByID.fulfilled, (state, { payload }) => {
      state.user = payload;
      state.loading = "loaded";
      state.editing = true;
    });
    builder.addCase(fetchUserByID.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deleteUser.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(deleteUser.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updateUser.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(updateUser.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(filterUsers.pending, (state) => {
      state.usersFilter = [];
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(filterUsers.fulfilled, (state, { payload }) => {
      state.usersFilter = payload;
      state.loading = "loaded";
    });
    builder.addCase(filterUsers.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(createUser.pending, (state) => {
      state.message = "";
      state.loading = "loading";
      state.editing = false;
    });
    builder.addCase(createUser.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(createUser.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(activateUser.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(activateUser.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(activateUser.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(deactivateUser.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(deactivateUser.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(deactivateUser.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
    builder.addCase(updatePassword.pending, (state) => {
      state.message = "";
      state.loading = "loading";
    });
    builder.addCase(updatePassword.fulfilled, (state, { payload }) => {
      // state.message = payload;
      state.loading = "loaded";
    });
    builder.addCase(updatePassword.rejected, (state, action) => {
      state.loading = "error";
      state.error = action.error.message;
    });
  },
});

export const { setUser, setLastQuery, setUsersAmount } = usersSlice.actions;
export const selectUsers = createSelector(
  (state) => ({
    users: state.users,
    usersList: state.users.usersList,
    loading: state.users.loading,
    error: state.users.error,
    editing: state.users.editing,
    user: state.users.user,
    userAccount: state.users.userAccount,
    usersAmount: state.users.usersAmount,
    lastQuery: state.users.lastQuery,
  }),
  (state) => state
);
export default usersSlice.reducer;
